import { render } from "./mlCriteriaCapture.vue?vue&type=template&id=b2d99172&scoped=true"
import script from "./mlCriteriaCapture.js?vue&type=script&lang=js"
export * from "./mlCriteriaCapture.js?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
import "./mlCriteriaCapture.vue?vue&type=style&index=1&id=b2d99172&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2d99172"]])

export default __exports__